/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PricingScheduleItemDto
 */
export interface PricingScheduleItemDto {
    /**
     *
     * @type {string}
     * @memberof PricingScheduleItemDto
     */
    startCronExpression?: string;
    /**
     *
     * @type {string}
     * @memberof PricingScheduleItemDto
     */
    endCronExpression?: string;
    /**
     * Optional description.
     * @type {string}
     * @memberof PricingScheduleItemDto
     */
    description?: string;
    /**
     *
     * @type {number}
     * @memberof PricingScheduleItemDto
     */
    priceKWh?: number;
}

/**
 * Check if a given object implements the PricingScheduleItemDto interface.
 */
export function instanceOfPricingScheduleItemDto(
    value: object,
): value is PricingScheduleItemDto {
    return true;
}

export function PricingScheduleItemDtoFromJSON(
    json: any,
): PricingScheduleItemDto {
    return PricingScheduleItemDtoFromJSONTyped(json, false);
}

export function PricingScheduleItemDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): PricingScheduleItemDto {
    if (json == null) {
        return json;
    }
    return {
        startCronExpression:
            json["startCronExpression"] == null
                ? undefined
                : json["startCronExpression"],
        endCronExpression:
            json["endCronExpression"] == null
                ? undefined
                : json["endCronExpression"],
        description:
            json["description"] == null ? undefined : json["description"],
        priceKWh: json["priceKWh"] == null ? undefined : json["priceKWh"],
    };
}

export function PricingScheduleItemDtoToJSON(
    value?: PricingScheduleItemDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        startCronExpression: value["startCronExpression"],
        endCronExpression: value["endCronExpression"],
        description: value["description"],
        priceKWh: value["priceKWh"],
    };
}
